/**
 * Traducao dos erros do cadastro de cartao para mensagens de usuario.
 *
 * O backend devolve o codigo no CORPO da resposta - { error: "CODIGO" } nos
 * 400 e { message: "CODIGO" } nos 401. O axios nao expoe isso em
 * error.message, que e sempre "Request failed with status code XXX": era essa
 * string que estava chegando na tela.
 */

const NETWORK_ERROR = 'Sua conexão está instável. Por favor, tente mais tarde.';

const GENERIC_ERROR =
  'Não foi possível cadastrar o cartão. Por favor, tente novamente.';

/**
 * Unico 400 sem corpo no PostUserPaymentMethods e o limite de cartoes, que
 * alem de recusar o cadastro bloqueia a conta por 30 minutos.
 */
const CARD_LIMIT_ERROR =
  'Você atingiu o limite de cartões cadastrados. Remova um cartão para adicionar outro. Por segurança, novas tentativas ficam bloqueadas por 30 minutos.';

const MESSAGES_BY_CODE: Record<string, string> = {
  ERR_CARD_ALREADY_REGISTERED:
    'Este cartão já está cadastrado na sua conta. Verifique a lista de cartões salvos.',
  STRIPE_PAYMENT_METHOD_ALREADY_ATTACHED_TO_ANOTHER_CUSTOMER:
    'Este cartão já está vinculado a outra conta. Use outro cartão ou fale com o suporte.',
  ERR_INVALID_USER:
    'Não foi possível validar sua sessão. Entre novamente e tente de novo.',
};

const extractCode = (error: any): string | undefined => {
  const data = error?.response?.data;

  if (!data || typeof data !== 'object') return undefined;

  const raw = data.error ?? data.message;

  return typeof raw === 'string' && raw.trim() ? raw.trim() : undefined;
};

export const getAddCardErrorMessage = (error: any): string => {
  if (error?.message === 'Network Error') return NETWORK_ERROR;

  const response = error?.response;

  if (response) {
    const code = extractCode(error);

    if (code && MESSAGES_BY_CODE[code]) return MESSAGES_BY_CODE[code];

    // paymentError.message ja vem pronta para o usuario (PaymentErrorMapper do
    // backend) — ex.: o endereco de cobranca que a Pagar.me exige no cadastro.
    const paymentErrorMessage = response.data?.paymentError?.message;
    if (typeof paymentErrorMessage === 'string' && paymentErrorMessage.trim()) {
      return paymentErrorMessage.trim();
    }

    if (response.status === 400 && !code) return CARD_LIMIT_ERROR;

    // Codigos de infra/configuracao (chave ausente, gateway nao configurado)
    // nao ajudam o usuario e nao podem vazar para a tela.
    return GENERIC_ERROR;
  }

  // Erro lancado pelo proprio fluxo do app: a mensagem ja esta em portugues.
  return error?.message || GENERIC_ERROR;
};
